import {
  pushAnalyticsObjToDataLayer,
  removeAndCleanLink,
  sanitizeTextArticle,
} from "@/utils/helper"

export const addAnalyticsOnClick = (
  eventInfoKey,
  item,
  quadrantTitle = "",
  url
) => {
  const internalLinkPosition = sanitizeTextArticle(quadrantTitle.toLowerCase())
  let eventInfo
  const brandName = item?.brandNameOne?.toLowerCase() ?? ""
  switch (eventInfoKey) {
    case "firstLink":
      eventInfo = {
        clickInternalLinks: `${item?.newTabOne ? "false" : "true"}`,
        internalLinkPosition: `${internalLinkPosition}`,
        internalLinkZoneName: "global footer",
        internalLinkURL: url
          ? `${
              url.indexOf("http") === -1 ? window.location.origin : ""
            }${removeAndCleanLink(url)}`
          : "n/a",
        internalLinkName: `${brandName}`,
        eventName: `footer menu:${brandName}`,
        internalLinkType: "global footer:navigation",
        eventType: "footer submenu",
        eventAction: `footer menu:${brandName}`,
      }
      break

    case "linkThree":
      eventInfo = {
        clickInternalLinks: `${item?.newTabFour ? "false" : "true"}`,
        internalLinkPosition: `${internalLinkPosition}`,
        internalLinkZoneName: "global footer",
        internalLinkURL: url
          ? `${
              url.indexOf("http") === -1 ? window.location.origin : ""
            }${removeAndCleanLink(url)}`
          : "n/a",
        internalLinkName: `${item?.brandNameFour?.toLowerCase()}`,
        eventName: `footer menu:${item?.brandNameFour?.toLowerCase()}`,
        internalLinkType: "global footer:navigation",
        eventType: "footer submenu",
        eventAction: `footer menu:${item?.brandNameFour?.toLowerCase()}`,
      }
      break
    case "oddEven":
      eventInfo = {
        clickInternalLinks: `${item?.newTabTwo ? "false" : "true"}`,
        internalLinkPosition: `${internalLinkPosition}`,
        internalLinkZoneName: "global footer",
        internalLinkURL: url
          ? `${
              url.indexOf("http") === -1 ? window.location.origin : ""
            }${removeAndCleanLink(url)}`
          : "n/a",
        internalLinkName: `${item?.brandNameTwo?.toLowerCase()}`,
        eventName: `footer menu:${item?.brandNameTwo?.toLowerCase()}`,
        internalLinkType: "global footer:navigation",
        eventType: "footer submenu",
        eventAction: `footer menu:${item?.brandNameTwo?.toLowerCase()}`,
      }
      break
    default:
      eventInfo = null
  }

  pushAnalyticsObjToDataLayer(eventInfo ?? null)
}
